import { AppRoutes } from '../../app.app-manager-routes';
import { EntityManagerInfo } from '../../models/entity-config';

// Censimento delle voci del modulo fatture: solo dati, nessuna EMC (spec 2026-10-19 §5).
// Generato da tools/split-app-manager-routes.mjs; le EMC stanno nel data delle rotte e nelle EMC che aprono le modali.
export class FattureRoutes {
  static readonly FattFatturaList: EntityManagerInfo = {
    id: 'FattFatturaList',
    name: 'fattfattura',
    translateSuffixs: ['generic.', 'fattfattura.'],
    url: 'fattfatturalist',
    parent: AppRoutes.Fatture
  };
}
